import ax1 from "assets/images/ax11.png";
import ax2 from "assets/images/cmp.png";
import ax3 from "assets/images/ax1.svg";
import styles from "./homeCom.module.css";
import LoginTatclub from "../common/lofinTatclub/LoginTatclub";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useContext } from "react";
import Container from "components/LogIn/Container";

const HomeComponent = ({ setItemss, updater, setUpdater }) => {
  // const [UserInformation, setUserInformation] = useState(User.getInfo());
  function changeUserInformation(newInfo) {
    // return setUserInformation(newInfo);
  }
  const auth = useContext(WithAuthentication);
  return (
    <div>
      <div className="d-flex justify-content-between">
        <img src={ax1} className={styles.ax1} />

        <div className={styles.bluPic}>
          <h1>تات کلاب</h1>
          <p className={styles.clickP}>
            {" "}
            فقط با چند کلیک فروشگاه اینترنتی خود را راه اندازی کنید{" "}
          </p>
          <div className={styles.eshtrak}>
            {!auth.isLogged ? (
              <span
                className={styles.eshtrakP}
                data-bs-toggle="modal"
                data-bs-target="#ModalNumber"
              >
                خرید اشتراک تات کلاب
              </span>
            ) : (
              <div className="user-link" style={{ marginRight: "60px" }}>
                <span
                  className={styles.eshtrakP}
                  data-bs-toggle="modal"
                  data-bs-target={`#exampleModal3`}
                  id="open-login-modal"
                >
                  خرید اشتراک تات کلاب
                </span>
              </div>
            )}
          </div>
        </div>

        <Container changeUserInformation={changeUserInformation} />
        <LoginTatclub
          setItemss={setItemss}
          updater={updater}
          setUpdater={setUpdater}
        />

        <div className={styles.up}>
          <div className="d-flex flex-column align-items-center  h-100 justify-content-around">
            <h1 className="mt-5"> تات کلاب</h1>
            <p className="text-center my-3" style={{ width: "299px" }}>
              فقط با چند کلیک فروشگاه اینترنتی خود را راه اندازی کنید{" "}
            </p>
            <img src={ax3} className={styles.bgBluje} />
            {/* <h5
              className={styles.tect}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModal3`}
            >
              خرید اشتراک تات کلاب
            </h5> */}
            {!auth.isLogged ? (
              <span
                className={styles.tect}
                data-bs-toggle="modal"
                data-bs-target="#ModalNumber"
              >
                خرید اشتراک تات کلاب
              </span>
            ) : (
              <span
                className={styles.tect}
                data-bs-toggle="modal"
                data-bs-target={`#exampleModal3`}
                id="open-login-modal"
              >
                خرید اشتراک تات کلاب
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeComponent;
